import React from 'react';
import { AiOutlineArrowRight } from 'react-icons/ai';

import './CampaignBanner.scss';

const CampaignBanner = () => {
  return (
    <div className="banner">
      <p>
         Hire me {' '}
        <a
          href="https://www.linkedin.com/in/kanav-sharma-6258901a8/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Click Here <AiOutlineArrowRight />
        </a>
      </p>
    </div>
  );
};

export default CampaignBanner;
